import React from 'react';
import { Municipality, getFeesForYear, filterFees, DEFAULT_ENABLED_CATEGORIES } from '@/lib/data';

interface BreakdownWidgetProps {
  municipality: Municipality;
  year: number;
  enabledCategories?: string[];
  dark?: boolean;
}

const FEE_COLORS = ['bg-blue-400', 'bg-sky-400', 'bg-amber-400', 'bg-rose-400', 'bg-violet-400'];

export const BreakdownWidget: React.FC<BreakdownWidgetProps> = ({ municipality, year, enabledCategories = DEFAULT_ENABLED_CATEGORIES, dark }) => {
  const fees = filterFees(getFeesForYear(municipality, year), enabledCategories);
  const total = fees.reduce((s, f) => s + f.amount, 0);
  const maxFee = Math.max(...fees.map(f => f.amount), 1);

  return (
    <div className={dark ? 'text-slate-300' : ''}>
      <p className={`text-xs font-medium mb-3 ${dark ? 'text-slate-400' : 'text-warmGray'}`}>
        {municipality.name} · {year}
      </p>
      <div className="space-y-2">
        {fees.map((fee, i) => (
          <div key={fee.id} className="flex items-center gap-3">
            <div className="min-w-[6rem] shrink-0">
              <span className="text-xs whitespace-nowrap">{fee.name}</span>
            </div>
            <div className={`flex-1 h-2 rounded-full overflow-hidden ${dark ? 'bg-slate-700' : 'bg-gray-100'}`}>
              <div
                className={`h-full rounded-full ${FEE_COLORS[i % FEE_COLORS.length]} opacity-75`}
                style={{ width: `${(fee.amount / maxFee) * 100}%` }}
              />
            </div>
            <span className={`text-xs w-14 text-right tabular-nums ${dark ? 'text-slate-400' : 'text-warmGray'}`}>
              {fee.amount.toLocaleString('nb-NO')} kr
            </span>
          </div>
        ))}
      </div>
      <div className={`pt-2 mt-2 border-t ${dark ? 'border-slate-600' : 'border-gray-200'}`}>
        <p className={`text-sm font-medium ${dark ? 'text-white' : 'text-deepCharcoal'}`}>
          Totalt {total.toLocaleString('nb-NO')} kr/år
        </p>
      </div>
    </div>
  );
};
